import { useState } from "react";
import clsx from "clsx";

const navItems = [
  "ARTISTS & WRITERS",
  "NEWS",
  "FILM, TV + MEDIA",
  "SONGS",
  "ABOUT",
  "CONTACT"
];

export default function MainNav({
  onOpenWindow
}: {
  onOpenWindow?: () => void;
}) {
  const [active, setActive] = useState("SONGS");

  return (
    <div className="w-full max-w-6xl px-4">
      {/* Desktop nav */}
      <nav className="hidden sm:flex justify-end">
        <ul className="flex justify-center gap-8 text-sm font-semibold text-gray-700">
          {navItems.map((item) => (
            <li
              key={item}
              onClick={() => {
                setActive(item);
                onOpenWindow && onOpenWindow();
              }}
              className={clsx(
                "cursor-pointer px-2 py-3 transition-colors duration-200",
                active === item
                  ? "bg-[#0071bb] text-white"
                  : "hover:text-[#0071bb]"
              )}
            >
              {item}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
